import { Validator } from '@vista-digital/validator';
export const formEventsValidatorSchema = {
    onBeforeSubmit: Validator.optional(Validator.fn()),
    onAfterSuccessfulSubmit: Validator.optional(Validator.fn()),
    onAfterFailedSubmit: Validator.optional(Validator.fn()),
    onCancelButtonClicked: Validator.optional(Validator.fn()),
    onFormSubmittingStateChanged: Validator.optional(Validator.fn())
};
export const formEventsValidator = Validator.object(formEventsValidatorSchema);
export const formEventsWithSubmitValidatorSchema = Object.assign(Object.assign({}, formEventsValidatorSchema), { onSubmit: Validator.fn() });
export const formEventsWithSubmitValidator = Validator.object(formEventsWithSubmitValidatorSchema);
